export default __webpack_public_path__ + "static/media/phoneCall.89fcfcf1.svg";